export default "__VITE_ASSET__BYZAIEK7__"